import { DataQualityLabel, DataQualityValue } from 'pages/my-vehicles/my-vehicles.props';

export const DATA_QUALITY_ID = {
  GOOD: 'good',
  BAD: 'bad',
  AVERAGE: 'average'
};

export const DATA_QUALITY_CONFIG = {
  [DATA_QUALITY_ID.GOOD]: {
    color: '#30BF30',
    label: 'Datenqualität ist gut',
    filterValue: { serverValue: DataQualityValue.Good, clientValue: DataQualityLabel.Good }
  },
  [DATA_QUALITY_ID.BAD]: {
    color: '#BF0040',
    label: 'Datenqualität ist schlecht',
    filterValue: { serverValue: DataQualityValue.Bad, clientValue: DataQualityLabel.Bad }
  },
  [DATA_QUALITY_ID.AVERAGE]: {
    color: '#FF9700',
    label: 'Datenqualität ist mittel',
    filterValue: { serverValue: DataQualityValue.Average, clientValue: DataQualityLabel.Average }
  }
};
